import React, { useEffect, useState } from 'react';
import registeredEventsStyles from '../../styles/evnetListStyles';
import BodyContainer from '../BodyContainer';
import EventCard from '../EventCard';
// import EventCard from "../eventCard/EventCard";
// import CustomButton from '../viewEventUi/CustomButton';
import Loader from '../Loader';
import Services from '../../services/services';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useHistory } from 'react-router-dom';
import EmptyMessage from './EmptyMessage.js';
// import image from "../assets/sup1.jpg";

const useStyles = makeStyles((theme) => registeredEventsStyles(theme));

function HostedEvents({ image, userId, userType, isNotHostOrAdmin }) {
  const classes = useStyles();
  const history = useHistory();
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    getListOfEvents();
  }, []);

  const getListOfEvents = () => {
    userId || setLoader(false);
    userId &&
      Services.list_host_events(userId)
        .then((res) => {
          setLoader(false);
          setData(res.data.listOfHostEvents);
          return null;
        })
        .catch((err) => {
          setLoader(false);
          return null;
        });
  };
  return (
    <BodyContainer stye={{marginBottom: '10px'}} title="Host Events">
      {data?.length ? (
        data?.map((each) => {
          
          // const isEventCancelled = each?.eventStatus === "cancelled";

          return (
            // isEventCancelled || (
            <EventCard
              data={each}
              key={each.eventId}
              image={image}
              userType={userType}
              userId={userId}
              dataFrom="HostedEvents"
            />
            // )
          );
        })
      ) : (
        <EmptyMessage />
      )}
      {/* <div>
        {isNotHostOrAdmin ? null : (
          <CustomButton
            btnStyle={classes.button}
            clickHandle={() => history.push('/newevent')}
            btnText={'Create Event'}
          />
        )}
      </div> */}
      <Loader open={loader} />
    </BodyContainer>
  );
}

export default HostedEvents;
